import { render, staticRenderFns } from "./GavelIconSvgChecked.vue?vue&type=template&id=9639f826&scoped=true"
import script from "./GavelIconSvgChecked.vue?vue&type=script&lang=ts"
export * from "./GavelIconSvgChecked.vue?vue&type=script&lang=ts"
import style0 from "./GavelIconSvgChecked.vue?vue&type=style&index=0&id=9639f826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9639f826",
  null
  
)

export default component.exports